/* eslint-env browser, jquery */
import 'bootstrap';
import container from 'modules/section-content';
import domify from 'domify';
import page from 'modules/ab-page-js';
import { assign, pick } from 'lodash';
import splash from './ambassador-program.pug';
import metadata from './metadata.json';

const FORM_SELECTOR = 'form.apply-form';
const BUTTON_SELECTOR = `${FORM_SELECTOR} button`;
const FIELDS_SELECTOR = `${FORM_SELECTOR} input, ${FORM_SELECTOR} textarea`;

export default function register() {
  page('/ambassador-program', render, snippets);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}

function snippets(ctx, next) {
  setupContactForm();

  $('.form-apply').on('click', () => {
    scrollAnimated($('#form-apply').offset().top, 600);
  });

  next();
}

function scrollAnimated(to, duration) {
  let start = $(window).scrollTop(), change = to - start, currentTime = 0, increment = 20;

  function easeInOut(currentTime, startValue, change, duration) {
    currentTime /= duration / 2;

    if (currentTime < 1) {
      return change / 2 * currentTime * currentTime + startValue;
    }

    currentTime -= 1;

    return -change / 2 * (currentTime * (currentTime - 2) - 1) + startValue;
  }

  function animateScroll() {
    currentTime += increment;

    const val = easeInOut(currentTime, start, change, duration);

    $(window).scrollTop(val);

    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  }

  animateScroll();
}

function setupContactForm() {
  $(FORM_SELECTOR).submit(sendForm);
}

function sendForm(e) {
  e.preventDefault();

  const $button = $(BUTTON_SELECTOR);

  if (
    $button.hasClass('success') ||
    $button.hasClass('btn-danger') ||
    $button.hasClass('btn-loading')
  ) {
    return;
  }

  setSubmitButtonState($button, 'process');

  const bodyFields = ['name', 'email', 'message'];
  const dataFields = ['country', 'city-province', 'link'];
  const fields = $(FIELDS_SELECTOR).toArray().reduce((result, current) => {
    result[current.name] = current.value;
    return result;
  }, {});

  const initial = {
    source: 'ambassador-program',
    subject: `Ambassador program contact from ${fields.name}`
  };

  const body = assign(initial, pick(fields, bodyFields), { data: pick(fields, dataFields) });

  return $.post('https://auth0-marketing.run.webtask.io/contact-form', body)
    .done(() => setSubmitButtonState($button, 'success'))
    .fail(() => setSubmitButtonState($button, 'error'))
    .always(
      () =>
        setTimeout(() =>
          $(FIELDS_SELECTOR).each((idx, field) => {
            field.value = '';
          })
        ),
      3000
    );
}

function setSubmitButtonState(submitButton, state) {
  switch (state) {
    case 'success':
      submitButton
        .removeClass('btn-danger shake btn-loading')
        .addClass('btn-success success tada')
        .html('<span aria-hidden="true" class="btn-icon icon-budicon-390"></span> Sent');
      setTimeout(() => setSubmitButtonState(submitButton, 'initial'), 3000);
      break;

    case 'error':
      submitButton
        .removeClass('btn-success success btn-loading tada')
        .addClass('btn-danger shake')
        .html('<span aria-hidden="true" class="btn-icon icon-budicon-389"></span> Error');
      setTimeout(() => setSubmitButtonState(submitButton, 'initial'), 2000);
      break;

    case 'process':
      submitButton
        .removeClass('success btn-danger')
        .addClass('btn-loading')
        .html('<span aria-hidden="true" class="icon-rotating icon-budicon-330"></span>');
      break;

    default:
      submitButton
        .removeClass('success btn-danger btn-loading tada shake')
        .addClass('btn-success')
        .html('APPLY');
  }
}



// WEBPACK FOOTER //
// ./src/pages/ambassador-program/ambassador-program.js